import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=05c7bd2a&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"
import style0 from "./notification.vue?vue&type=style&index=0&id=05c7bd2a&prod&lang=scss&scoped=true"
import style1 from "./notification.vue?vue&type=style&index=1&id=05c7bd2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c7bd2a",
  null
  
)

export default component.exports